'use client';

import * as React from 'react';

import { UserIdDisplay } from '~/components/user-id-display';

export function Footer(): React.JSX.Element {
  return (
    <footer className="sm:container">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="flex flex-col items-center gap-2 sm:items-start">
          <UserIdDisplay />
        </div>
      </div>
    </footer>
  );
}
